import React from 'react';

import styles from './gallery.module.scss';
import { Image } from '@utmb/design-system/image/Image';
import { Font } from '@utmb/design-system/text/font';
import CloudinaryMediaView from '@utmb/types/view/CloudinaryMediaView';
import isMobile from '@utmb/utils/is-mobile';
import { getColorStyle } from '@utmb/utils/colors';
import { ColorTypesEnum } from '@utmb/types/colors';

interface GalleryImageProps {
    photo: CloudinaryMediaView;
    index: number;
    left: number;
    top: number;
    setCurrentImage: (index: number) => void;
    setViewerIsOpen: (isOpen: boolean) => void;
    isDark?: boolean;
    title?: string;
    isSquared?: boolean;
}

const GalleryImage = (props: GalleryImageProps) => {
    const { photo, setCurrentImage, setViewerIsOpen, index, title, isSquared } = props;

    const handleOpenModal = () => {
        setCurrentImage(index);
        setViewerIsOpen(true);
    };

    return (
        <div
            style={{
                width: isSquared ? (isMobile() ? 150 : 312) : photo.width,
                height: isSquared ? (isMobile() ? 150 : 312) : photo.height,
                backgroundColor: '#eee',
                cursor: 'pointer',
                overflow: 'hidden',
                position: 'relative',
                margin: '2px',
            }}
            className={styles.photoGallery}
            onClick={handleOpenModal}
            role={'none'}
        >
            <div className={styles.imageOverlay}></div>
            <Image
                image={photo}
                alt={photo.alt}
                className={styles.imgGallery}
                objectFit={isSquared ? 'cover' : 'contain'}
                objectPosition={'center'}
                style={{
                    transition: 'transform .135s cubic-bezier(0.0,0.0,0.2,1),opacity linear .15s',
                }}
            />

            {title && (
                <div className={[styles.description].join(' ')}>
                    <Font.FuturaBold desktop="20" mobile="18" color={getColorStyle(ColorTypesEnum.WHITE)}>
                        {title}
                    </Font.FuturaBold>
                </div>
            )}
        </div>
    );
};

export default GalleryImage;
